import axios from "axios";
import { IDocumentListFilter } from "./document-list-view/interfaces/document-list-filter.interface";

const prefix: string = 'Documents/';

export const getDocuments = (search: IDocumentListFilter) => {
    return axios.post(`${prefix}GetDocuments`, search);
}